import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import Mirror from './Mirror';
import Countdown from './Countdown';
import LineChartX from './LineChartX';
import Button from './Button';
import Video from './Video';
import ShowInput from './ShowInput';
import Summary from './Summary';
import Gallery from './Gallery';
import Tabs from './Tabs';
import Holder from './Holder';
import Space from './Space';
import Image from './Image';
import ShowIcon from './ShowIcon';

function App(props) {

  var height = props.height;
  var width = props.width;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var internalVariables = props.internalVariables;
  var interactionFn = props.interactionFn;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var chains = props.chains;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var stylesToAdd = props.stylesToAdd;
  var clickEditItem = props.clickEditItem;
  var addClassNames = props.addClassNames;
  var dragStuff = props.dragStuff;
  var parentalType = props.parentalType;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var upwardInfo = props.upwardInfo;
  var addWhereText = props.addWhereText;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var doAScreenRef = props.doAScreenRef;
  var flashHighlight = props.flashHighlight;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  var thisItem = props.thisItem;
  var itemInfoPath = props.itemInfoPath;

  var editPieces = props.editPieces;
  var needToShowError = props.needToShowError;

  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;

  var errorString = false;
  if (needToShowError && !interactionFn){
    var error = editPieces.error;
    errorString = CoreFns.errorString(error);
  }

  var type = thisItem.t;
  var isError = false;

  var itemInfoPathString = itemInfoPath.join(' ');
  if (!interactionFn){
    if (itemEdited && itemEdited.t === 'item' && itemEdited.path.join(' ') === itemInfoPathString){
      addClassNames += ' editing';
    }else if (hoveringWhere === itemInfoPathString){
      addClassNames += ' preEditing';
    }else if (errorString){
      if (errorString.indexOf(itemInfoPathString) === 0){
        addClassNames += ' editingError';
        isError = true;
      }
    } 
  }

  var allStyles = StyleFunctions.evaluateStyleR(type, thisItem.s, itemInfoPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  if (interactionFn){
    StyleFunctions.addPointerIfGotClick(thisItem, allStyles);
    if (allStyles.gHideWhen){
      allStyles.display = 'none';
    }
  }

  StyleFunctions.modStyleWithFlashHighlight(allStyles, flashHighlight, itemInfoPathString);

//
  var clickFn = function(e){
      e.stopPropagation();
  }

  if (interactionFn){
    clickFn = function(e){
      var aPossib = 'click';
      var ocSet = thisItem.oc;
      interactionFn(e, ocSet, aPossib, upwardInfo, itemInfoPath.concat(['oc', aPossib]));
    }
  }else if (clickEditItem){
    clickFn = function(e){
      clickEditItem({t:'item', path:itemInfoPath})(e);
    }
  }

  var draggable = false;
  var onDragStart = null;
  var onDrag = null;
  var onDragEnd = null;
  if (dragStuff){
    draggable = true;
    onDragStart = dragStuff.dragStart('all', itemInfoPath);
    onDrag = dragStuff.onDrag;
    onDragEnd = dragStuff.dragEnd;
    stylesToAdd.cursor = 'move';
  }

  if (!allStyles.borderWidth){
    delete allStyles.borderWidth;
  }

  var addCC = '';
  var addCCColWidth = '';
  if (parentalType === 'HFLEX'){
    var toIt = ['colWidth'];
    toIt.forEach((aIt, index)=>{
      var name = aIt;
      if (name === 'colWidth'){
        name = 'col';
      }
      if (allStyles[aIt]){
        addCCColWidth += ' ' + name + '-' + allStyles[aIt];
      }else if (aIt === 'colWidth'){
        addCCColWidth += ' ' + name + '-3';
      }

    })

    // stylesToAdd.textAlign = 'right'
  }else if (parentalType === 'CARD'){
    addCC = ' card-body';
  }

  var toIt1 = ['mt', 'mb', 'ml', 'mr'];
  toIt1.forEach((aIt, index)=>{
    var name = aIt;
    if (allStyles[aIt]){
      addCC += ' ' + name + '-' + allStyles[aIt];
    }

  })

  if (StyleFunctions.canScroll(type)){
    if (allStyles.scrollIn){
      addClassNames += ' jsScroll';
      if (!interactionFn){
        if (lastEdited !== itemInfoPathString){
          addClassNames += ' scrolled';    
        }
      }
      addClassNames += ' '  + allStyles.scrollIn;
    }
  }

  addClassNames += addCC;

  if (type === 'IMG'){

    return <Image chains={chains} parentalType={parentalType} thisItem={thisItem} allStyles={allStyles} stylesToAdd={stylesToAdd} height={height} width={width} currentList={currentList} internalVariables={internalVariables} inputValues={inputValues} upwardInfo={upwardInfo} actHoveringWhere={actHoveringWhere} clickFn={clickFn} ownVariables={ownVariables} addClassNames={addClassNames} addCCColWidth={addCCColWidth} draggable={draggable} onDrag={onDrag} onDragStart={onDragStart} onDragEnd={onDragEnd} itemInfoPath={itemInfoPath} doAScreenRef={doAScreenRef} itemInfoPathString={itemInfoPathString} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader}/>
//    


  }else if (type === 'SUMMARY'){

    return <Summary chains={chains} allStyles={allStyles} itemPath={itemInfoPath} thisItem={thisItem} currentList={currentList} internalVariables={internalVariables} width={width} height={height} inputValues={inputValues} ownVariables={ownVariables} clickEditItem={clickEditItem} interactionFn={interactionFn} doAScreenRef={doAScreenRef} upwardInfo={upwardInfo} setInputValues={setInputValues} editPieces={editPieces} itemEdited={itemEdited} setItemEdited={setItemEdited} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} organicChanges={organicChanges} userNos={userNos} userID={userID} clickFn={clickFn} draggable={draggable} onDragStart={onDragStart} onDragEnd={onDragEnd} onDrag={onDrag} popUps={popUps} setPopUps={setPopUps} stylesToAdd={stylesToAdd} addClassNames={addClassNames} addCCColWidth={addCCColWidth} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>


  }else if (type === 'VIDEO'){
    var isResponsiveX = false;
    if (itemInfoPath[4] === 'k' || itemInfoPath.length > 6){
      isResponsiveX = true;
    }
    var covering = null;
    if (!interactionFn && addClassNames.indexOf(' editing') === -1){
      covering = <div style={{position:'absolute',left:5,right:5,top:5,bottom:5,zIndex:1, textAlign:'center', padding:'5px', backgroundColor:'#FFFFFF80'}} onClick={clickFn}>Click to Edit</div>
//
    }

    return <Video key={itemInfoPathString} allStyles={allStyles} addClasses={addClassNames + addCCColWidth} isResponsive={isResponsiveX} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')} covering={covering} stylesToAdd={stylesToAdd} doAScreenRef={doAScreenRef} itemPath={itemInfoPath}/>
//
  }else if (type === 'ICON'){

    return <ShowIcon key={itemInfoPathString} clickFn={clickFn} addClassNames={addClassNames} addCCColWidth={addCCColWidth} allStyles={allStyles} stylesToAdd={stylesToAdd} actHoveringWhere={actHoveringWhere} itemInfoPathString={itemInfoPathString} itemPath={itemInfoPath} doAScreenRef={doAScreenRef}/>
//
//
  }else if (type === 'SPACE'){

    return <Space addClassNames={addClassNames} addCCColWidth={addCCColWidth} style={{...allStyles, ...stylesToAdd}} clickFn={clickFn} interactionFn={interactionFn} actHoveringWhere={actHoveringWhere} itemInfoPathString={itemInfoPathString} itemPath={itemInfoPath} doAScreenRef={doAScreenRef}/>
//
  }else if (type === 'BUTTON'){

    return <Button isError={isError} doAScreenRef={doAScreenRef} itemPath={itemInfoPath} allStyles={allStyles} stylesToAdd={stylesToAdd} addClasses={addClassNames + addCCColWidth} interactionFn={interactionFn} clickFn={clickFn} draggable={draggable} onDragStart={onDragStart} onDragEnd={onDragEnd} onDrag={onDrag} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')} />


  }else if (type === 'GALLERY'){

    return <Gallery chains={chains} thisItem={thisItem} itemInfoPath={itemInfoPath} currentList={currentList} internalVariables={internalVariables} width={width} height={height} upwardInfo={upwardInfo} inputValues={inputValues} ownVariables={ownVariables} allStyles={allStyles} stylesToAdd={stylesToAdd} interactionFn={interactionFn} clickFn={clickFn} popUps={popUps} setPopUps={setPopUps} actHoveringWhere={actHoveringWhere} addClassNames={addClassNames} addCCColWidth={addCCColWidth} draggable={draggable} onDragStart={onDragStart} onDragEnd={onDragEnd} onDrag={onDrag} itemInfoPathString={itemInfoPathString} doAScreenRef={doAScreenRef} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader}/>
//
  }else if (type === 'TABS'){

    return <Tabs chains={chains} thisItem={thisItem} screenSelectionChoices={screenSelectionChoices} itemInfoPathString={itemInfoPathString} setScreenSelectionChoices={setScreenSelectionChoices} interactionFn={interactionFn} clickEditItem={clickEditItem} itemInfoPath={itemInfoPath} currentList={currentList} internalVariables={internalVariables} width={width} height={height} upwardInfo={upwardInfo} inputValues={inputValues} ownVariables={ownVariables} setInputValues={setInputValues} editPieces={editPieces} addClassNames={addClassNames} addWhereText={addWhereText} organicChanges={organicChanges} userNos={userNos} userID={userID} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} doAScreenRef={doAScreenRef} popUps={popUps} setPopUps={setPopUps} allStyles={allStyles} itemEdited={itemEdited} setItemEdited={setItemEdited} clickFn={clickFn} stylesToAdd={stylesToAdd} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} addCCColWidth={addCCColWidth} potentiallyAddWhichItem={potentiallyAddWhichItem} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>


  }else if (CoreFns.isHolder(type)){

    return <Holder userID={userID} thisItem={thisItem} chains={chains} type={type} allStyles={allStyles} stylesToAdd={stylesToAdd} height={height} width={width} currentList={currentList} internalVariables={internalVariables} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={itemEdited} setItemEdited={setItemEdited} editPieces={editPieces} clickEditItem={clickEditItem} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} upwardInfo={upwardInfo} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} organicChanges={organicChanges} userNos={userNos} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} clickFn={clickFn} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} addClassNames={addClassNames} addCCColWidth={addCCColWidth} draggable={draggable} onDrag={onDrag} onDragStart={onDragStart} onDragEnd={onDragEnd} itemInfoPath={itemInfoPath} doAScreenRef={doAScreenRef} itemInfoPathString={itemInfoPathString} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>

//
  }else if (type === 'DIV' || type === 'SUMMARYDIV'){

      var styleWrap1 = {position:'relative'};
      if (itemEdited && itemEdited.t === 'item' && itemEdited.path.join(' ') === itemInfoPathString){
        if (type === 'DIV' || (type === 'SUMMARYDIV' && isClickingOnContentDiv) ){
          addCC += ' editing';
        }
      }

      function setItemClicked(e){
        if (clickEditItem){
          clickEditItem({t:'item', path:itemInfoPath})(e);
        }else{
          e.stopPropagation();
        }
      }
      
      return <Mirror chains={chains} userID={userID} itemPath={itemInfoPath} currentList={currentList} width={width} height={height} userNos={userNos} internalVariables={internalVariables} error={editPieces.error} itemEdited={itemEdited} setItemClicked={setItemClicked} onClickItemChangeSelection={editPieces.onClickItemChangeSelection} organicChanges={editPieces.organicChanges} updatesToPropagate={editPieces.updatesToPropagate} inputValues={inputValues} ownVariables={ownVariables} refObject={editPieces.refObject} getRef1={editPieces.getRef1} className={addCC + addCCColWidth} styleWrap={styleWrap1} interactionFn={interactionFn} setIsClickingOnContentDiv={setIsClickingOnContentDiv} upwardInfo={upwardInfo} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} dragStuff={false} setIsShowingSomeDropDown={false} counter={counter}/>

  }else if (type === 'LINECHART'){

    var dataSources = thisItem.d;
    var dataKeys = CoreFns.sortedKeyList(dataSources);
    var dataSet = dataKeys.map((aKey, index)=>{
      var aSource = dataSources[aKey];
      var allStyles = StyleFunctions.evaluateStyleR('LINEDATA', aSource.s, itemInfoPath.concat(['d', aKey]), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      return allStyles;
    })

    return <LineChartX key={itemInfoPathString} itemPath={itemInfoPath} doAScreenRef={doAScreenRef} className={addClassNames + addCCColWidth} onClick={clickFn} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')} allStyles={{...stylesToAdd, ...allStyles}} dataSet={dataSet}/>

//    
  }else if (type === 'INPUT'){

    var onChangeFn = function(e){
      // window.alert('You are currently in design mode. Use preview mode to see effects of changes to your options.');
    }
    if (interactionFn){
      onChangeFn = function(newValue){
        var aPossib = 'change';
        var ocSet = thisItem.oc;
        interactionFn(false, ocSet, aPossib, upwardInfo.concat([{t:'input',v:newValue}]), itemInfoPath.concat(['oc', aPossib]));
      }
    }
    var addClassNamesHereV1 = StyleFunctions.iterateClassNames('', ['vTop', 'textAlignment'], allStyles);

    var cc = {...stylesToAdd, ...allStyles};
      StyleFunctions.sortOutBackgroundColor(cc, thisItem.s, itemInfoPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, false);

    return <ShowInput currentList={currentList} allStyles={cc} upwardInfo={upwardInfo} onChangeFn={onChangeFn} setInputValues={setInputValues} idNos={itemInfoPathString} inputValues={inputValues} onClick={clickFn} addClassNamesA={addCCColWidth + addClassNames} addClassNamesB={addClassNamesHereV1} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} parentalType={parentalType} interactionFn={interactionFn} options={allStyles.options} doAScreenRef={doAScreenRef} itemPath={itemInfoPath}/>
  }else if (type === 'TIMER'){
    return <Countdown insideStyle={allStyles} addClassNames={addClassNames + addCCColWidth} outsideStyle={stylesToAdd} draggable={draggable} onClick={clickFn} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} itemPath={itemInfoPath} doAScreenRef={doAScreenRef} />
//    
  // }else if (type === 'HR'){

  //   return <HR allStyles={allStyles} addCCColWidth={addCCColWidth} actHoveringWhere={actHoveringWhere} itemInfoPathString={itemInfoPathString} doAScreenRef={doAScreenRef} itemPath={itemInfoPath}/>
  }else{
    return <div>Error</div>
  }
}
//




export default App;
